import * as React from 'react';

class Summary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: null,
      data: null, // 具体要显示的内容
      strContent: null,
    };
  }
  UNSAFE_componentWillMount() {
    console.log('this.props.content', this.props.content);
    if (this.props.content) {
      this.setState({ content: this.props.content }, () => {
        this.findData();
      });
    }
  }

  componentDidUpdate(prevProps) {
    if(prevProps.content !== this.props.content) {
      this.setState({ content: this.props.content }, () => {
        this.findData();
      });
    }
  }
  
  // 查找要显示的内容
  findData = () => {
    let content = this.state.content;
    console.log('content: ', content);
    if (content && content.length > 0) {
      let find = content.find(v => { return v.label === 'htri_ele' });
      if (find && find.content && find.content.length > 0) {
        let find2 = find.content.find(y => { return y.label === 'line_chart' });
        if (find2) {
          this.setState({ data: find2 }, () => {
            console.log(this.state.data);
          });
        }
      }
      find = content.find(v => { return v.label === 'ills_ele' });
      if (find && find.content && find.content.length > 0) {
        let find2 = find.content.find(y => { return y.label === 'illustration' });
        if (find2) {
          this.setState({ strContent: find2.content }, () => {
            console.log(this.state.strContent);
          });
        }
      }
    }
  }
  render() {
    return (
      <React.Fragment>
        {
          this.state.data &&
          <React.Fragment>
            <img src={'data:image/jpeg;base64,' + this.state.data.content.data} alt="" />
            {/* <div dangerouslySetInnerHTML={{ __html: this.state.data.content }} /> */}
            <p>
              {this.state.strContent}
            </p>
          </React.Fragment>
        }
      </React.Fragment>
    );
  }
}

export default Summary;